import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset-advanced';

export default createGlobalStyle`
  ${reset};

  body {
    font-family: 'Lato', 'Helvetica Neue', 'Helvetica', sans-serif;
    font-weight: 500;
    overflow-x: hidden;
    width: 100%;
  }

  /*! locomotive-scroll v3.5.4 | MIT License | https://github.com/locomotivemtl/locomotive-scroll */
  * .animation-on-viewport {
  }
  @keyframes appearGeneric {
    0% {
      transform:translateY(103%);
      opacity: 0;
    }
    100% {
      transform:translateY(0);
      opacity: 1;
    }
  }
  @keyframes appearImage {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  
  html.has-scroll-smooth * .animation-on-viewport {
    transform:translateY(103%);
    opacity: 0;
  }
  html.has-scroll-smooth * .animation-on-viewport-image {
    opacity: 0;
  }
  html.has-scroll-smooth * .animation-on-viewport-image.is-inview {
    animation: appearImage 0.4s forwards cubic-bezier(0.5,0,0,1);
    animation-delay: 0.4s;
  }
  html.has-scroll-smooth * .animation-on-viewport.is-inview {
    animation: appearGeneric 0.4s forwards cubic-bezier(0.5,0,0,1);
    animation-delay: 0.4s;
  }


  html.has-scroll-smooth {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    overflow: hidden; }

  html.has-scroll-dragging {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none; }

  .has-scroll-smooth body {
          position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    overflow: hidden; }
  .has-scroll-smooth #scroll-container {
      min-height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
  }
  #scroll-container {
    transition: opacity 0.75s cubic-bezier(0.5,0,0,1);
  }
  .has-scroll-smooth [data-scroll-container] {
     }

  #___gatsby, #gatsby-focus-wrapper {
          position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
  }
  .c-scrollbar {
    position: absolute;
    right: 0;
    top: 0;
    width: 11px;
    height: 100vh;
    transform-origin: center right;
    transition: transform 0.3s, opacity 0.3s;
    opacity: 0; }
    .c-scrollbar:hover {
      transform: scaleX(1.45); }
    .c-scrollbar:hover, .has-scroll-scrolling .c-scrollbar, .has-scroll-dragging .c-scrollbar {
      opacity: 1; }

  .c-scrollbar_thumb {
    position: absolute;
    top: 0;
    right: 0;
    background-color: black;
    opacity: 0.5;
    width: 7px;
    border-radius: 10px;
    margin: 2px;
    cursor: -webkit-grab;
    cursor: grab; }
    .has-scroll-dragging .c-scrollbar_thumb {
      cursor: -webkit-grabbing;
      cursor: grabbing; }




  .select__value-container {
    margin-top: 10px;
  }
`;
